import { render, staticRenderFns } from "./PerformanceKpis.vue?vue&type=template&id=3883e0c5&"
import script from "./PerformanceKpis.vue?vue&type=script&lang=js&"
export * from "./PerformanceKpis.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceKpis.vue?vue&type=style&index=0&id=3883e0c5&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports